import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IElectivePayload, IElectiveStudentGroup, IElectiveStudents, IInitialStateElective } from "../types";
import { GetDeleteElective, GetElective, GetItemElective } from "./thunk";

const initialState: IInitialStateElective = {
    elective: [],
    electiveRestore: [],
    isLoadingElective: true,
    selectedElectiveIDs: [],
    isViewElectiveRestore: false,
    electiveStudents: {
        id: 0,
        elective_subject_blocks: [],
    },
    electiveStudentGroup: [],
};

const electiveSlice = createSlice({
    name: "elective",
    initialState,
    reducers: {
        setElective: (state, action: PayloadAction<IElectivePayload[]>) => {
            state.elective = action.payload;
        },
        deletedElective: (state, action: PayloadAction<number>) => {
            state.elective = state.elective.filter(elem => elem.id !== action.payload);
        },

        setRestoreElective: (state, action) => {
            state.electiveRestore = action.payload;
        },
        deletedRestoreElective: (state, action) => {
            state.electiveRestore = state.electiveRestore.filter(elem => elem.id !== action.payload);
        },
        setIsViewRestoreElective: state => {
            state.isViewElectiveRestore = !state.isViewElectiveRestore;
        },
        setSelectedElectiveIDs: (state, action) => {
            state.selectedElectiveIDs = action.payload;
        },
        setElectiveStudent: (state, action: PayloadAction<IElectiveStudents>) => {
            state.electiveStudents = action.payload;
        },
        setElectiveStudentGroup: (state, action: PayloadAction<IElectiveStudentGroup[]>) => {
            state.electiveStudentGroup = action.payload;
        },
        clearElectiveData: state => {
            state.electiveStudents = {
                id: 0,
                elective_subject_blocks: [],
            };
            state.electiveStudentGroup = [];
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetElective.pending, state => {
                state.isLoadingElective = true;
            })
            .addCase(GetElective.fulfilled, state => {
                state.isLoadingElective = false;
            })
            .addCase(GetElective.rejected, state => {
                state.isLoadingElective = false;
            })
            .addCase(GetDeleteElective.pending, state => {
                state.isLoadingElective = true;
            })
            .addCase(GetDeleteElective.fulfilled, state => {
                state.isLoadingElective = false;
            })
            .addCase(GetDeleteElective.rejected, state => {
                state.isLoadingElective = false;
            })
            .addCase(GetItemElective.pending, state => {
                state.isLoadingElective = true;
            })
            .addCase(GetItemElective.fulfilled, state => {
                state.isLoadingElective = false;
            })
            .addCase(GetItemElective.rejected, state => {
                state.isLoadingElective = false;
            });
    },
});

export const {
    setSelectedElectiveIDs,
    deletedElective,
    deletedRestoreElective,
    setIsViewRestoreElective,
    setRestoreElective,
    setElective,
    setElectiveStudent,
    setElectiveStudentGroup,
    clearElectiveData,
} = electiveSlice.actions;

export default electiveSlice;
